import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fromAllergenArray'
})
export class FromAllergenArrayPipe implements PipeTransform {
  transform(collection: Array<any>, prefix: string = ''): string {
    if (collection.length > 0) {
      return `${prefix} ${collection.map(x => x.name.trim()).join(', ')}`;
    } else {
      return `No Allergens`;
    }
  }
}
